import { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'libs/styled';
import { above } from '@sportson/core-web/utils/mediaqueries';
import AccordionHeader from './AccordionHeader';

const Wrapper = styled('div')``;

const AnimationWrapper = styled('div')`
    display: grid;
    grid-template-rows: ${({ active }) => (active ? '1fr' : '0fr')};
    transition: all 250ms;

    .content {
        overflow: hidden;
        width: 100%;
        justify-self: flex-start;
        margin-bottom: ${({ active }) => (active ? '24px' : '0')};

        ul,
        ol {
            list-style-position: outside;
            margin-left: 0;
            padding-left: 40px;

            > * + * {
                margin-top: 0.5em;
            }
        }

        ul {
            margin-top: 0.5em;
            list-style-type: unset;
        }

        ol {
            margin-top: 0.5em;
            list-style-type: lower-latin;
        }

        > * + * {
            margin-top: 32px;
        }

        span {
            > * + * {
                margin-top: 32px;
            }
        }

        ${above['tablet.lg']} {
            max-width: 631px;
            justify-self: center;
            transform: translateY(-${({ contentTransformY }) => contentTransformY}px);
            margin-bottom: ${({ active, contentTransformY }) => (active ? `calc(80px - ${contentTransformY}px)` : '0')};
        }
    }
`;

const Accordion = ({ active, label, children, ...props }) => {
    const [show, setShow] = useState(active);
    const contentTransformY = 49;

    if (!children) {
        return null;
    }

    const toggleShow = useCallback(() => {
        setShow((active) => !active);
    }, []);

    return (
        <Wrapper {...props}>
            <AccordionHeader label={label} active={show} onClick={toggleShow} />
            <AnimationWrapper active={show} contentTransformY={contentTransformY}>
                <div className="content">{children}</div>
            </AnimationWrapper>
        </Wrapper>
    );
};

Accordion.propTypes = {
    active: PropTypes.bool,
    children: PropTypes.node.isRequired,
    label: PropTypes.string,
};

Accordion.defaultProps = {
    active: false,
    label: '',
};

export default Accordion;
